import { loginSuccess, logout } from "@store/member/memberAuthSlice";
import {
  setMemberInfoData,
  clearMemberInfoData,
} from "@store/member/memberInfoSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";

export const useLoginHandler = () => {
  const dispatch = useDispatch();

  return (data) => {
    if (!data) return;

    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("signature", data.signature);
    localStorage.setItem("token_expire_time", data.token_expire_time);

    dispatch(
      loginSuccess({
        token: data.access_token,
        signature: data.signature,
        tokenExpireTime: data.token_expire_time,
      })
    );
  };
};

export const useLogoutAndClear = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  return () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("signature");
    localStorage.removeItem("token_expire_time");
    localStorage.removeItem("sua_id");
    dispatch(logout());
    dispatch(clearMemberInfoData());

  };
};
